<template>
    <card>
        <card-header>
            <card-overline>P-Wareneingang</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Eingangsdatum</th>
                    <th>Liefermenge</th>
                    <th>QK bestanden</th>
                    <th>Kommentar</th>
                    <th>Operator</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="incoming in incomingGoodsProducer" :key="incoming.index">
                    <td>{{ incoming.incoming_goods_at_string }}</td>
                    <td>{{ incoming.amount_string }}</td>
                    <td>{{ incoming.quality_control_string }}</td>
                    <td>{{ incoming.comment }}</td>
                    <td>{{ incoming.admin_user.name }}</td>
                    <td>
                        <form-button icon="document-edit" dense="true" @click="incomingGoodsProducerModal = !incomingGoodsProducerModal; editIncomingGoodsProducer = incoming" />

                        <form-button type="button" dense="true"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.delivery.incoming-goods-producer.delete', {'askForQuote': this.askForQuote, 'incomingGoodsProducer': incoming.id})"
                                     icon="trash-delete-bin-2"/>
                    </td>
                </tr>
                </tbody>
            </table>
            <modal-dialog title="P-Wareneingang löschen" text="Möchten Sie den P-Wareneingang wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>
        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary"  icon="package-box-arrow"
                         @click="incomingGoodsProducerModal = !incomingGoodsProducerModal; editIncomingGoodsProducer = null" :disabled="disabledTab || ! hasProducerOrder">
                neuer Wareneingang
            </form-button>
            <incoming-goods-producer-modal :askForQuote="askForQuote"
                                           :incomingGoodsProducer="editIncomingGoodsProducer"
                                           v-if="incomingGoodsProducerModal"
                                           @closeDialog="incomingGoodsProducerModal = false"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import IncomingGoodsProducerModal from '@partfactory/Pages/Admin/AskForQuote/Modals/IncomingGoodsProducerModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
export default {
    name: 'IncomingGoodsProducer',
    components: {
        ModalDialog, IncomingGoodsProducerModal, FormButton, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
    data() {
        return {
            editIncomingGoodsProducer: null,
            incomingGoodsProducerModal: false,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        incomingGoodsProducer() {
            let incomingGoodsProducer = [];
            this.askForQuote.incoming_goods_producer.forEach(incoming => {
                incoming.incoming_goods_at_string = this.$moment(incoming.incoming_goods_at).format('DD.MM.YYYY');
                incoming.amount_string = incoming.amount + ' von ' + this.askForQuote.producer_order.amount;
                incoming.quality_control_string = incoming.quality_control ? 'Ja' : 'Nein';

                incomingGoodsProducer.push(incoming);
            });

            return incomingGoodsProducer;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasProducerOrder() {
            return !! this.askForQuote?.producer_order?.id;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
